import React, { PureComponent } from 'react';
import { Icon, Row, Col } from 'antd';
import { get } from 'lodash';
import { LinkType, EffectiveTime, UploadPicture } from '../../tools';
import { LinkTypeMode } from '../../../types';

const getImageSize = (imageUrl: string, callback: Function) => {
    const img = new Image();
    img.onload = function() {
        const width = img.width;
        const height = img.height;
        callback(null, width, height);
    };
    img.onerror = function() {
        callback('Failed to load image', null, null);
    };
    img.src = imageUrl;
};

//图片广告位项
interface IProps {
    sourceRoot?: {
        image?: string;
    };
    item?: any;
    uploadAction?: string;
    linkTypes?: Array<any>;
    linkTypeMode?: LinkTypeMode;
    effectiveTime?: { start: string; end: string };
    selector: any;
    onChangeItem: (e: any) => void;
}

export class ImageAdItem extends PureComponent<IProps> {
    handleChangeItem = (path: string) => {
        const { onChangeItem } = this.props;
        getImageSize(path, (err: any, width: any, height: any) => {
            if (!err) {
                onChangeItem({
                    item: { path: `${path}?width=${width}&height=${height}` },
                    type: 'add',
                });
            }
        });
    };

    render() {
        const {
            item,
            linkTypes,
            linkTypeMode,
            uploadAction,
            selector,
            sourceRoot,
            onChangeItem,
        } = this.props;

        return (
            <Row className="entry-item">
                <Icon
                    type="close"
                    className="item-remove"
                    title="移除"
                    onClick={() => onChangeItem({ item: null, type: 'del' })}
                />
                <Col className="entry-item-image" span={6}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={item.path}
                        uploadAction={uploadAction}
                        onChange={(path) => this.handleChangeItem(path)}
                    />
                </Col>
                <Col className="entry-item-content" span={17}>
                    <LinkType
                        selector={selector}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        onChange={(e) => onChangeItem({ item: e, type: 'add' })}
                    />
                    <EffectiveTime
                        value={{ effectiveTime: get(item, 'effectiveTime', null) }}
                        onChange={(e) => onChangeItem({ item: e, type: 'add' })}
                    />
                </Col>
            </Row>
        );
    }
}
